import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-designation',
  templateUrl: './create-designation.component.html',
  styleUrls: ['./create-designation.component.css']
})
export class CreateDesignationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
